import {useContext} from "react";
import {useNavigate} from "react-router-dom";
import { formatDistanceToNow } from 'date-fns';
import { de } from 'date-fns/locale'
import OrderOptions from "../../configs/OrderOptions";
import 'react-circular-progressbar/dist/styles.css';
import CardDetailsMenu from "./cardDetailsMenu";
import {ParserGermanDate} from "../../helper/dateFormatHandler";
import {UserBadge} from "../../helper/userHelper";
import {TranslateOrderStatus} from "../../helper/orderStageHandler";
import {EntityContext} from "../../context/EntityContext";
import {UserContext} from "../../context/UserContext";
import {Analytics} from "../../helper/analyticsHandler"

export const CardDetails = ({orders,sBl, currentSetting}) => {
    const {
        setCurrentEntity,
        setOpenDeleteModal,
        setOpenShareMapsLink,
        setOpenPlanToOrderModal,
        setOpenPlanRefModal,
        setPlanAndFilesModal,
      } = useContext(EntityContext);

    const {
        user,
        company,
      } = useContext(UserContext);

    const creator = orders?.createdByUserName ? orders?.createdByUserName : orders?.createdByCompanyName;

    const navigate = useNavigate();

    const getLink = (type) => {
        if (type === "myPlans") {
            return `/viewer/${orders?.id}`
        } else if (type === "myMaps") {
            return `/maps/${orders?.id}`
        } else if (type === "myOrder") {
            return `/order/${orders?.id}`
        } else if (type === "ordersManagement") {
            return `/order/${orders?.id}`
        } else if (type === "ordersTender") {
            return `/order/${orders?.id}`
        }
    }

    const getOptionValue = (field, value)  => {
        return OrderOptions(field,value);
    }

    const getStageValue2 = (field,orders,value) => {
        const a = TranslateOrderStatus(orders?.[value]);
        // <div>{a?.label}</div>

        return (
            <div className={"flex justify-between"}>
                <div className="w-full bg-gray-200 rounded-full h-1.5  ">
                    <div className={`${stuckInProgress(orders?.updatedAt, orders?.stage) ? 'bg-red' : 'bg-gray-900'} h-1 rounded-full`} style={{width: a?.value+"%"}}></div>
                </div>
            </div>
        );

    }

    const stuckInProgress = (updatedAt, stage) => {
        if ((stage === "contracted" || stage === "inDevelopment" || stage === "inReview" ) && updatedAt) {
            const diff = new Date().getTime() - updatedAt;
            // more than 30 days 
            if (diff > 2592000000) {
                return true;
            }
        }
        return false;
    }

    const getStageValue = (field,orders,value) => {
        const a = TranslateOrderStatus(orders?.[value]);
        return a?.label+ " ("+a?.value+"%)";

    }

    return (
       <div className={(orders?.hidden === true) ? ("hidden"):("")}>
           <div className={(sBl === true ) ? "opacity-50 bg-white border border-gray-500 text-gray-900 p-6 rounded-lg h-full relative" : "h-full bg-white relative   border border-gray-500 text-gray-900 p-6 rounded-lg"} style={{boxShadow: "0 0 30px 0 rgba(0,0,0,.03)"}}>


                    <div className={"flex w-full justify-between cursor-pointer font-bold "}>

                        {( currentSetting?.type === "myOrder" || currentSetting?.type === "ordersManagement" || currentSetting?.type === "ordersTender")? (
                            <div style={{"width":"calc(100% - 40px)"}} className={"text-lg break-all whitespace-normal  font-semibold text-gray-900"} onClick={() => {if(sBl !== true ) { Analytics("usage",`open ${currentSetting?.type}`, `${user?.id}-${orders?.id}`,orders?.id);  navigate(getLink(currentSetting?.type))}}}>
                                {"Auftrag: "+orders?.planId}
                            </div>
                        ) : (
                            <div style={{"width":"calc(100% - 40px)"}}  className={"text-lg break-all whitespace-normal font-semibold text-gray-900"} onClick={() => {if(sBl !== true ) { Analytics("usage",`open ${currentSetting?.type}`, `${user?.id}-${orders?.id}`,orders?.id);  navigate(getLink(currentSetting?.type))}}}>
                                {orders?.name}
                            </div>

                        ) }

                        <div className={"w-[40px] items-start justify-items-center flex"}>
                           <div className={"-mt-2 -mr-2"}>
                               {(sBl !== true && orders?.createdByCompany === company?.id) && (
                                   <EntityContext.Provider value={{
                                        orders,
                                        setCurrentEntity,
                                        setOpenDeleteModal,
                                        setOpenShareMapsLink,
                                        setOpenPlanToOrderModal,
                                        setOpenPlanRefModal,
                                        setPlanAndFilesModal,
                                        currentSetting
                                   }}>
                                       <CardDetailsMenu/>
                                   </EntityContext.Provider>
                               )}
                           </div>
                        </div>
                    </div>

               {(orders?.stage && (currentSetting?.type !== "ordersManagement" && currentSetting?.type !== "ordersTender")) && (
                   <div className={"mt-3 -mb-2"}>
                       <div title={orders?.stage} className={`text-xs mb-2  truncate text-right text-gray-600/80`}>{getStageValue2("name",orders,"stage")}</div>
                       <div className={"grid gap-x-6 gap-y-2 h-auto lg:grid-cols-[100px_1fr] grid-cols-1"}>
                          <span className={"text-xs "}>Status</span>
                          <span title={orders?.stage} className={"text-xs  truncate text-right text-gray-600/80"}>{getStageValue("name",orders,"stage")}</span>
                       </div>
                   </div>
               )}

               <div className={"grid my-4 gap-x-6 gap-y-2 h-auto lg:grid-cols-[100px_1fr] grid-cols-1 mb-10"}>

                        {(orders?.createdByCompany && orders?.createdByCompany !== '') && (<span className={"text-xs "}>Auftraggeber</span>)}
                        {(orders?.createdByCompanyName && orders?.createdByCompanyName !== '') && (<span title={orders?.createdByCompanyName} className={"text-xs  truncate text-right text-gray-600/80"}>{orders?.createdByCompanyName}</span>)}

                        {(orders?.updatedAt && orders?.updatedAt !== '') && (<span className={"text-xs "}>Letzte Änderung</span>)}
                        {(orders?.updatedAt && orders?.updatedAt !== '') && (<span title={orders?.updatedAt} className={`text-xs truncate text-right text-gray-600/80`}>{formatDistanceToNow(new Date(+orders?.updatedAt), {addSuffix: true, locale: de })}</span>)}

                        {(orders?.planDetails?.name && orders?.planDetails?.name !== '') && (<span className={"text-xs "}>Name</span>)}
                        {(orders?.planDetails?.name && orders?.planDetails?.name !== '') && (<span title={orders?.planDetails?.name} className={"text-xs  truncate text-right text-gray-600/80"}>{orders?.planDetails?.name}</span>)}

                        {(orders?.planId && orders?.planId !== '') && (<span className={"text-xs "}>Nummer</span>)}
                        {(orders?.planId && orders?.planId !== '') && (<span  title={orders?.planId} className={"text-xs  truncate text-right text-gray-600/80"}>{orders?.planId}</span>)}

                        {(orders?.planDetails?.community?.name && orders?.planDetails?.community?.name !== '') && (<span className={"text-xs "}>Gemeinde</span>)}
                        {(orders?.planDetails?.community?.name && orders?.planDetails?.community?.name !== '') && (<span  title={orders?.planDetails?.community?.name} className={"text-xs  truncate text-right text-gray-600/80"}>{orders?.planDetails?.community?.name}</span>)}

                        {(orders?.type && orders?.type !== '') && (<span className={"text-xs "}>Art</span>)}
                        {(orders?.type && orders?.type !== '') && (<span  title={orders?.type} className={"text-xs  truncate truncate text-right text-gray-600/80"}>{orders?.type}</span>)}

                        {(orders?.planDetails?.orderTypes && orders?.planDetails?.orderTypes !== '') && (<span className={"text-xs "}>Auftrag</span>)}
                        {(orders?.planDetails?.orderTypes && orders?.planDetails?.orderTypes !== '') && (<span  title={orders?.planDetails?.orderTypes} className={"text-xs  truncate text-right text-gray-600/80"}>{getOptionValue("orderTypes",orders?.planDetails?.orderTypes)}</span>)}

                        {(orders?.planDetails?.plotArea && orders?.planDetails?.plotArea !== '') && (<span className={"text-xs "}>Plangröße</span>)}
                        {(orders?.planDetails?.plotArea && orders?.planDetails?.plotArea !== '') && (<span  title={orders?.planDetails?.plotArea} className={"text-xs  truncate text-right text-gray-600/80"}>{orders?.planDetails?.plotArea} ha</span>)}

                        {(orders?.planDetails?.projection && orders?.planDetails?.projection !== '') && (<span className={"text-xs "}>Projektion</span>)}
                        {(orders?.planDetails?.projection && orders?.planDetails?.projection !== '') && (<span  title={orders?.planDetails?.projection} className={"text-xs  truncate text-right text-gray-600/80"}>{orders?.planDetails?.projection}</span>)}

                        {(orders?.planDetails?.requestedXPlanVersion && orders?.planDetails?.requestedXPlanVersion !== '') && (<span className={"text-xs "}>XPlan Version</span>)}
                        {(orders?.planDetails?.requestedXPlanVersion && orders?.planDetails?.requestedXPlanVersion !== '') && (<span  title={orders?.planDetails?.requestedXPlanVersion} className={"text-xs  truncate text-right text-gray-600/80"}>{orders?.planDetails?.requestedXPlanVersion}</span>)}

                    </div>


                    <div className={"text-gray-600/60 text-xs w-full box-border bottom-4 -m-6 p-6  absolute items-end justify-items-center flex  justify-between"}>
                        <div>
                            {orders?.createdAt && (
                                <span>Erstellt am: <span className={"text-gray-600"}>{ParserGermanDate(orders?.createdAt)}</span></span>
                            )}
                        </div>
                        <div className={"-mb-2"}>
                            {UserBadge(creator,"Ersteller", 8, 'xs')}
                        </div>

                    </div>

           </div>
       </div>
    );
}

